import {Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {LoaderService} from "../../services/loader.service";
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent implements OnInit {
  loading = '';
  printPage='fixed';
  constructor(private loaderService:LoaderService,
              private router:Router) {
    router.events.forEach((event) => {
      event instanceof NavigationEnd ?
        this.checkIsPrintPage(event) : null;
    });
  }

  ngOnInit() {
    this.loaderService.isLoading().subscribe(_isLoading => {
      this.loading = _isLoading ? 'noscroll' : '';
    });
    $(document).ready(function () {
      var trigger = $('.hamburger'),
        overlay = $('.overlay'),
        isClosed = false;

      trigger.click(function () {
        hamburger_cross();
      });

      function hamburger_cross() {

        if (isClosed == true) {
          overlay.hide();
          trigger.removeClass('is-open');
          trigger.addClass('is-closed');
          isClosed = false;
        } else {
          overlay.show();
          trigger.removeClass('is-closed');
          trigger.addClass('is-open');
          isClosed = true;
        }
      }

      $('[data-toggle="offcanvas"]').click(function () {
        $('#wrapper').toggleClass('toggled');
        $('#sidebar-wrapper').toggleClass('toggled');
        $('#page-content-wrapper').toggleClass('toggled');
        $('#navbar').toggleClass('toggled');
      });
    });
  }

  checkIsPrintPage(event) {
    this.printPage = event.url.indexOf('/print') ? 'fixed' : '';
  }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/layout/app-layout/app-layout.component.ts